import PocketBase from 'pocketbase';

const url = process.env.REACT_APP_POCKETBASE_URL;
if (!url) {
  throw new Error('REACT_APP_POCKETBASE_URL is not set. Please create a .env file with this variable.');
}

const pb = new PocketBase(url);

export default pb;
